<template>
  <div class="any-qr-code">
    <div style="text-align: center; padding: 10px">
      <qr-canvas
        :options="options"
        style="margin: 0 auto; max-width: calc(100vw - 100px)"
      ></qr-canvas>
    </div>
  </div>
</template>

<script>
import { QRCanvas } from "qrcanvas-vue";

export default {
  name: "AnyQRCode",
  components: {
    QrCanvas: QRCanvas,
  },
  props: {
    url: String,
    showLogo: Boolean,
  },
  data() {
    return {
      logo: "/img/icons/round-180x180.png",
      // QR code generator options
      options: {
        cellSize: 8,
        correctLevel: "H",
      },
    };
  },
  created() {
    if (!this.showLogo) {
      this.options = Object.assign({}, this.options, {
        data: this.url,
      });
      return;
    }
    const image = new Image();
    image.src = this.logo;
    image.onload = () => {
      this.options = Object.assign({}, this.options, {
        logo: { image },
        data: this.url, //"https://tukapp.co/install",
      });
    };
  },
};
</script>

<style scoped>
</style>
